import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AuthProvider, AppConfigProvider } from '.';
import { Spinner } from '@fluentui/react';
import { MsrcApiConfigConnector } from './appConfig/apiConfig/MsrcApiConfigConnector';
/** All-in-one Component that provides a context for MSRC app configs and
 * authentication.
 * > Also suspends children rendering until config is loaded.
 *
 * @constant
 */
export const AppConfigAndAuthProvider = ({ children, configList, fallback = _jsx(Spinner, { label: 'Loading...' }), }) => (_jsx(AppConfigProvider, { configList: configList, fallback: fallback, children: _jsxs(AuthProvider, { children: [_jsx(MsrcApiConfigConnector, {}), children] }) }));
